import $ from "jquery";

export const instruction = function () {
	if (!($(".js-instructions-popup").length > 0)) return false; 

    $(".js-instructions-btn").on('click', function() {        	
        const $instructionsPopup = $(".js-instructions-popup");
        const hasOpened = $instructionsPopup.hasClass("is-active");
        const isOpen = !hasOpened;

        $instructionsPopup.toggleClass("is-active", isOpen);
    });

};
